import ABCyaLib from '@abcya/abcya_lib';

export default function setupGameConfig(variantId, locale) {
  const { esUS } = ABCyaLib.Environment.LOCALES;
  const config = {
    // add your game config options here, these can be the default values
    title: {
      title1StartY: 100,
      title1EndY: 240,
      title2StartY: 100,
      title2EndY: 600,
      peopleY: 0
    },
    waittimes: [1400,2800,700,2100,0]
  };
  switch (variantId) {
    // switch on your variant IDs here and set the needed config values
  }
  switch (locale) {
    case esUS:
      config.waittimes = [2200,4400,1100,3300,0];
      config.title = {
        title1StartY: 100,
        title1EndY: 512,
        title2StartY: 250,
        title2EndY: 512,
        peopleY: 25,
      };
      break;
  }
  return config;
}